import { ArrowRight, Check, Download, MapPin, RefreshCw, Star, Video } from 'lucide-react';
import { siteConfig } from '../siteConfig';

export const AboutPage = () => (
  <main id="top" className="as-about-page">
    <header className="as-about-hero">
      <div className="as-about-intro">
        <p className="as-descriptor">La personne derrière Auto Sens</p>
        <h1>Je suis Enzo Chevallier. J’aime autant choisir une voiture que la conduire.</h1>
        <p>
          Passionné d’automobile, je change de voiture à titre personnel chaque année depuis que
          j’ai le permis. Comparer les générations, les options, les prix, la décote et les points
          d’attention est devenu une méthode que je mets aujourd’hui au service d’autres particuliers.
        </p>
        <div className="as-about-actions">
          <a className="as-button as-button-dark" href="/#contact">Parler de mon projet <ArrowRight size={17} /></a>
          <a className="as-link" href="/documents/autosens-exemple-dossier.pdf" download>Télécharger le dossier exemple</a>
          <a className="as-link" href={siteConfig.googleBusinessUrl} target="_blank" rel="noreferrer"><Star size={15} aria-hidden="true" /> Auto Sens sur Google</a>
        </div>
      </div>
      <figure className="as-advisor-photo as-photo-placeholder">
        <span aria-hidden="true">EC</span>
        <figcaption>Photo d’Enzo à venir</figcaption>
      </figure>
    </header>

    <section className="as-about-story" aria-labelledby="about-story-title">
      <div>
        <span className="as-kicker">Expérience personnelle</span>
        <h2 id="about-story-title">Des voitures rationnelles, électriques et passion.</h2>
      </div>
      <div>
        <p>
          Cette habitude m’a fait passer par des citadines, des coupés, des roadsters, des sportives,
          des modèles électriques et des voitures familiales. Elle m’a surtout appris qu’un bon achat
          ne se résume ni à une marque, ni à une fiche technique : il dépend du bon exemplaire, du bon
          prix et surtout de l’usage attendu.
        </p>
        <p>
          À titre personnel, je cherche à me faire plaisir tout en maîtrisant autant que possible la
          perte à la revente. Cela nourrit mon attention au marché et à la décote, sans constituer une
          promesse de gain pour un client : les prix futurs restent incertains.
        </p>
      </div>
    </section>

    <section className="as-advisor-practice" aria-labelledby="advisor-practice-title">
      <div>
        <span className="as-kicker">Un échange adapté</span>
        <h2 id="advisor-practice-title">La même méthode, sur place ou à distance.</h2>
      </div>
      <dl className="as-advisor-practice-list">
        <div><RefreshCw size={21} aria-hidden="true" /><div><dt>Une voiture différente chaque année</dt><dd>Une pratique personnelle régulière de l’achat, de la comparaison du marché et de la revente.</dd></div></div>
        <div><MapPin size={21} aria-hidden="true" /><div><dt>Dans la région d’Angers</dt><dd>Je peux me déplacer lorsque le projet et le rendez-vous le justifient.</dd></div></div>
        <div><Video size={21} aria-hidden="true" /><div><dt>Partout ailleurs</dt><dd>Le cadrage, la présentation du dossier et le débrief se font en visioconférence ou par téléphone.</dd></div></div>
      </dl>
    </section>

    <section className="as-about-boundaries">
      <div>
        <span className="as-kicker">Ce que cela change</span>
        <h2>Une recommandation argumentée, avec ses limites visibles.</h2>
      </div>
      <ul>
        <li><Check size={16} />Comparaison des versions, prix, usages et coûts estimés.</li>
        <li><Check size={16} />Sources datées et hypothèses séparées des faits.</li>
        <li><Check size={16} />Aucune rémunération d’une marque, d’un vendeur ou d’un financement.</li>
        <li><Check size={16} />Aucune certitude mécanique ni remplacement d’une inspection physique.</li>
      </ul>
    </section>

    <section className="as-example-download" aria-labelledby="example-download-title">
      <div>
        <span className="as-kicker">Voir avant de décider</span>
        <h2 id="example-download-title">Un dossier complet, construit sur un cas fictif.</h2>
        <p>
          L’exemple montre le niveau de détail, la séparation entre faits et estimations, la
          shortlist et le plan d’action. Les personnes et le projet sont fictifs ; les sources sont datées.
        </p>
      </div>
      <a className="as-button as-button-lime" href="/documents/autosens-exemple-dossier.pdf" download>
        <Download size={17} /> Télécharger le PDF
      </a>
    </section>
  </main>
);
